import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SelectwithImage } from './SelectwithImage';
import DatePicker from "react-datepicker";
import Select, { StylesConfig } from "react-select";



const MainTasksSidebar = ({ activityTogglePopup, closeSidebar, isEditing }: any) => {

    const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
    const handleDateChange = (date: Date | null) => {
        setSelectedDate(date);
    };
    const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
    const handleDateChange1 = (date: Date | null) => {
        setSelectedDate1(date);
    };
    const options3 = [
        { value: "Choose", label: "Choose" },
        { value: "High", label: "High" },
        { value: "Low", label: "Low" },
        { value: "Medium", label: "Medium" },

    ]
    const options = [
        { value: "Choose", label: "Choose" },
        { value: "Project1", label: "Project1" },
        { value: "Project2", label: "Project2" },
        { value: "Project3", label: "Project3" },

    ]
    const options2 = [
        { value: "Select a status", label: "Select a status" },
        { value: "Completed", label: "Completed" },
        { value: "Started", label: "Started" },
        { value: "In Progress", label: "In Progress" },
        { value: "On Hold", label: "On Hold" },
        { value: "Cancelled", label: "Cancelled" },  
        { value: "Pending Review", label: "Pending Review" },  
      ];
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    return (
        <div className={activityTogglePopup ? "toggle-popup sidebar-popup" : "toggle-popup"}>
            <div className="sidebar-layout">
                <div className="sidebar-header">
                    <h4>{isEditing ? "Edit Task" : "New Task"} </h4>
                    <Link to="#" className="sidebar-close toggle-btn" onClick={closeSidebar}>
                        <i className="ti ti-x" />
                    </Link>
                </div>
                <div className="toggle-body">
                    <div className="toggle-height">
                        <div className="pro-create">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-wrap">
                                        <label className="col-form-label">
                                            Title <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            className="form-control"
                                            type='text'
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label className="col-form-label">
                                        Project<span className="text-danger"> *</span>
                                    </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={options}
                                    />
                                </div>
                                <div className='col-md-12 mt-2'>
                                    <div className="form-wrap">
                                        <label className="col-form-label">
                                            Assigned To
                                            <span className="text-danger">*</span>
                                        </label>
                                        <SelectwithImage />
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label className="col-form-label">
                                        Start Date <span className="text-danger">*</span>
                                    </label>
                                    <div className="form-wrap icon-form">
                                        <span className="form-icon">
                                            <i className="ti ti-calendar-check" />
                                        </span>
                                        <DatePicker
                                            className="form-control datetimepicker deals-details"
                                            selected={selectedDate}
                                            onChange={handleDateChange}
                                            dateFormat="dd-MM-yyyy"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label className="col-form-label">
                                        Due Date <span className="text-danger">*</span>
                                    </label>
                                    <div className="form-wrap icon-form">
                                        <span className="form-icon">
                                            <i className="ti ti-calendar-check" />
                                        </span>
                                        <DatePicker
                                            className="form-control datetimepicker deals-details"
                                            selected={selectedDate1}
                                            onChange={handleDateChange1}
                                            dateFormat="dd-MM-yyyy"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label className="col-form-label">
                                        Priority<span className="text-danger"> *</span>
                                    </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={options3}
                                    />
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label className="col-form-label">
                                        Status<span className="text-danger"> *</span>
                                    </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={options2}
                                    />
                                </div>
                                <div className="col-md-12 mt-2">
                                    <div className="form-wrap">
                                        <label className="col-form-label">
                                            Description <span className="text-danger">*</span>
                                        </label>
                                        <textarea
                                            className="form-control"
                                            rows={4}
                                            defaultValue={""}
                                            placeholder='Type....'
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="submit-button text-end">
                            <Link to="#" className="btn btn-light sidebar-close" onClick={closeSidebar}>
                                Cancel
                            </Link>
                            <Link
                                to="#"
                                className="btn btn-primary"
                                data-bs-target="#create_project"
                            >
                                {isEditing ? "Update" : "Save"}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainTasksSidebar;
